















































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  UnitBaseData, emptyData, UnitAreaData, UnitPositionData,
  getUnitInfo, postPart
} from '@/api/heritageUnit/unitBase'
import {
  validateIntKey, showVaildMsg, validatePhone, validateCompare
} from '@/configs/validate'
import {
  DDLItem, DefDDLItem, getLookupByType, getCitysByUser,
  getHeritageLevel, getHeritageClassify, getHeritageSubClassify,
  getHeritageBatch, getAreaType
} from '@/api/common/select'
import { enLookupType, enFirstType } from '@/configs/enums'
import {
  getDDLItem, getDDLName, getSubDDL, splitToIntList
} from '@/configs/functions'
// import UnitLngLat from '@/components/heritageUnit/form/lnglat.vue'
import UnitPositionList from '@/components/heritageUnit/form/positionList.vue'
import UnitFileList from '@/components/heritageUnit/form/fileList.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (id: number, form: { [key: string]: string }) => {
  return {
    // LevelId: [{ required: true, validator: validateIntKey('请选择单位级别'), trigger: 'change' }],
    // HeritageCode: [{ required: true, message: '请输入单位编号', trigger: 'blur' }],
    HeritageName: [
      { required: true, message: '请输入文物点名称', trigger: 'blur' }
    ],
    // AreaType: [{ validator: validateIntKey('请选择区域类型'), trigger: 'change' }],
    PublishClassifyId: [
      {
        required: true,
        validator: validateIntKey('请选择文物组成类型'),
        trigger: 'change'
      }
    ],
    // SubClassifyOther: [{ required: true, message: '请输入其他分类', trigger: 'blur' }],
    // SubClassifyId: [{ required: true, validator: validateIntKey('请选择单位子分类'), trigger: 'change' }],

    StatisticAgeId: [
      {
        required: true,
        validator: validateIntKey('请选择文物点时代'),
        trigger: 'change'
      }
    ],
    BatchId: [
      {
        required: true,
        validator: validateIntKey('请选择批次'),
        trigger: 'change'
      }
    ],
    PublishAddress: [
      { required: true, message: '请输入公布地址', trigger: 'blur' }
    ],
    DetailAddress: [
      { required: true, message: '请输入现地址', trigger: 'blur' }
    ],
    StateSummary: [{ required: true, message: '请输入简介', trigger: 'blur' }],

    SaveStatusId: [
      {
        required: true,
        validator: validateIntKey('请选择保存状况'),
        trigger: 'change'
      }
    ],
    SaveTypeId: [
      {
        required: true,
        validator: validateIntKey('请选择保存方式'),
        trigger: 'change'
      }
    ],

    arrNaturalDamageResIds: [
      { validator: validateNaturalDamageRes, formInfo: form, trigger: 'blur' }
    ],
    arrHumanDamageResIds: [
      { validator: validateHumanDamageRes, formInfo: form, trigger: 'blur' }
    ],
    // DamageDescription: [{ validator: validateDamageDescription, formInfo: form, trigger: 'blur' }],
    DamageDescription: [
      { required: true, message: '请输入损毁原因', trigger: 'blur' }
    ],

    InformantName: [
      { required: true, message: '请输入填报人姓名', trigger: 'blur' }
    ],
    InformantUnit: [
      { required: true, message: '请输入填报人单位', trigger: 'blur' }
    ],
    InformantTel: [
      { required: true, message: '请输入填报人联系电话', trigger: 'blur' }
    ],
    InformantEmail: [
      { required: true, message: '请输入填报人电子邮箱', trigger: 'blur' },
      { type: 'email', message: '电子邮箱格式不正确', trigger: 'blur' }
    ]
  }
}
const validateNaturalDamageRes = (
  rule: any,
  value: any,
  callback: (error?: Error) => void
) => {
  value = rule.formInfo.NaturalDamageIds
  if (
    rule.formInfo.IsDamage &&
    (value === undefined ||
      value === null ||
      value === [] ||
      value.length === 0)
  ) {
    callback(new Error('请选择自然损毁因素'))
  } else {
    callback()
  }
}
const validateHumanDamageRes = (
  rule: any,
  value: any,
  callback: (error?: Error) => void
) => {
  value = rule.formInfo.HumanDamageIds
  var hasNatural = rule.formInfo.NaturalDamageIds.length > 0
  if (
    rule.formInfo.IsDamage && !hasNatural &&
    (value === undefined ||
      value === null ||
      value === [] ||
      value.length === 0)
  ) {
    callback(new Error('请选择人为损毁因素'))
  } else {
    callback()
  }
}
const validateDamageDescription = (
  rule: any,
  value: string,
  callback: (error?: Error) => void
) => {
  if (
    rule.formInfo.IsDamage &&
    (value === undefined || value === null || value === '')
  ) {
    callback(new Error('请输入损毁原因'))
  } else {
    callback()
  }
}
@Component({
  components: { FormDialog, UnitPositionList, UnitFileList }
})
export default class UnitPartForm extends Vue {
  public name = 'UnitPartForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  public expandNames: string[] = [
    'basic',
    'position',
    'status',
    'pics',
    'draws',
    'info'
  ]
  public loading = false
  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)

  public form = Object.assign({}, emptyData)
  public levelList: DDLItem[] = []
  public propertyList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public subClassifyList: DDLItem[] = [this.defItem]
  public areaList: DDLItem[] = []
  public ageList: DDLItem[] = []
  public batchList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public heritageStatusList: DDLItem[] = []
  public heritageSaveList: DDLItem[] = []
  public naturalDamageResList: DDLItem[] = []
  public humanDamageResList: DDLItem[] = []

  // 文物组成类型中的其他
  public classifyOtherId: number = 0
  public showSubClassifyOther: boolean = false
  public naturalOtherId: number = 0
  public humanOtherId: number = 0
  get showDamageDesc(): boolean {
    const show =
      this.arrNaturalDamageResIds.indexOf(this.naturalOtherId) > -1 ||
      this.arrHumanDamageResIds.indexOf(this.humanOtherId) > -1
    return show
  }
  // #region vue中的计算属性
  // 单位属性
  get arrPropertyIds(): number[] {
    return splitToIntList(this.form.UnitPropertyIds)
  }
  set arrPropertyIds(newVal: number[]) {
    this.form.UnitPropertyIds = newVal.join(',')
  }
  // 人为损毁因素合集
  get arrHumanDamageResIds(): number[] {
    return splitToIntList(this.form.HumanDamageIds)
  }
  set arrHumanDamageResIds(newVal: number[]) {
    this.form.HumanDamageIds = newVal.join(',')
  }
  // 自然损毁因素合集
  get arrNaturalDamageResIds(): number[] {
    return splitToIntList(this.form.NaturalDamageIds)
  }
  set arrNaturalDamageResIds(newVal: number[]) {
    this.form.NaturalDamageIds = newVal.join(',')
  }
  // #endregion
  public rules: any = getFormRules(0, this.form)
  // dynamic component
  public $refs!: {
    formData: Element.Form
    picCtrl: UnitFileList
    drawCtrl: UnitFileList
    positionCtrl: UnitPositionList
  }
  public setCtrlsData() {
    if (this.$refs.positionCtrl) {
      this.$refs.positionCtrl.setData(this.form.PositionList)
    }
    if (this.$refs.picCtrl) {
      this.$refs.picCtrl.setData(this.form.Pictures)
    }
    if (this.$refs.drawCtrl) {
      this.$refs.drawCtrl.setData(this.form.Drawings)
    }
  }
  public getCtrlsData() {
    this.form.PositionList = this.$refs.positionCtrl.getData()
    this.form.Pictures = this.$refs.picCtrl.getData()
    this.form.Drawings = this.$refs.drawCtrl.getData()
  }
  public created() { }
  public mounted() {
    window.eventBus.$on(
      'openUnitPartForm',
      (info: { listId: number; dataId: number }) => {
        this.open()
        this.fetchSource()
        this.fetchData(info)
      }
    )
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitPartForm')
  }
  public open() {
    this.expandNames = ['basic']
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchSource() {
    var typeEmpty = enFirstType.None
    getHeritageLevel(this.firstType).then((response: { data: any }) => {
      this.levelList = response.data
    })
    getLookupByType(enLookupType.UnitProperty, typeEmpty).then(
      (response: { data: any }) => {
        this.propertyList = response.data
      }
    )
    getHeritageClassify(this.firstType).then((response: { data: any }) => {
      this.classifyList = response.data
      const otherIndex = response.data.findIndex(
        (v: DDLItem) => v.ExInfo.Flag2 == true
      )
      if (otherIndex >= 0) {
        this.classifyOtherId = response.data[otherIndex].Key
      }
    })
    getLookupByType(enLookupType.HeritageAge, this.firstType).then(
      (response: { data: any }) => {
        this.ageList = response.data
      }
    )
    getHeritageBatch(this.firstType).then((response: { data: any }) => {
      this.batchList = response.data
    })
    getCitysByUser(this.firstType).then((response: { data: any }) => {
      this.cityList = response.data
    })
    getLookupByType(enLookupType.HeritageSaveStatus, this.firstType).then(
      (response: { data: any }) => {
        this.heritageStatusList = response.data
      }
    )
    getLookupByType(enLookupType.HeritageSaveType, this.firstType).then(
      (response: { data: any }) => {
        this.heritageSaveList = response.data
      }
    )
    getLookupByType(enLookupType.NaturalDamageRes, typeEmpty).then(
      (response: { data: any }) => {
        this.naturalDamageResList = response.data
        const otherIndex = response.data.findIndex(
          (v: DDLItem) => v.ExInfo.Flag1 == true
        )
        if (otherIndex >= 0) {
          this.naturalOtherId = response.data[otherIndex].Key
        }
      }
    )
    getLookupByType(enLookupType.HumanDamageRes, typeEmpty).then(
      (response: { data: any }) => {
        this.humanDamageResList = response.data
        const otherIndex = response.data.findIndex(
          (v: DDLItem) => v.ExInfo.Flag1 == true
        )
        if (otherIndex >= 0) {
          this.humanOtherId = response.data[otherIndex].Key
        }
      }
    )
    getAreaType(typeEmpty).then((response: { data: any }) => {
      this.areaList = response.data
    })
  }
  public fetchData(info: { listId: number; dataId: number }) {
    const id = info.dataId
    getUnitInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.rules = getFormRules(this.form.Id, this.form)
        if (this.form.Id == 0) {
          // this.form = Object.assign({}, emptyData)
          this.form.ListId = info.listId
          this.$nextTick(() => {
            if (this.$refs.formData) {
              this.$refs.formData.clearValidate()
            }
          })
        }
        this.$nextTick(() => {
          this.setCtrlsData()
        })
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public sendData(data: UnitBaseData) {
    window.eventBus.$emit('submitUnitPartForm', {
      data: data
    })
  }
  public onSubmit() {
    this.getCtrlsData()
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        postPart(f).then(
          (response: { data: any }) => {
            const data = response.data
            const msg = this.form.Id > 0 ? '保存' : '创建'
            if (data && !data.IsError) {
              this.$message({
                message: `${msg}成功`,
                type: 'success'
              })
              this.sendData(f)
              this.close()
            } else {
              this.$message({
                dangerouslyUseHTMLString: true, message: `${data.Message}`,
                type: 'warning'
              })
              console.log(response)
            }
          },
          (data: any) => {
            console.log(data)
          }
        )
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
